import { debounce } from 'lodash';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

const _saveVideoPlayerVolume = ({
  volume,
  muted,
}: {
  volume: number;
  muted: boolean;
}) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.videoPlayerVolume,
      JSON.stringify({ volume, muted })
    );
  }
};

export const saveVideoPlayerVolume = debounce(_saveVideoPlayerVolume, 700);
